export const MY_ACCOUNT_URL = window.location.hostname.includes('uw.co.uk')
  ? 'https://myaccount.uw.co.uk'
  : 'https://myaccount.uw.je';

export const inLifeQuotingFieldsData: Record<string, string> = {
  account_number: '',
  basket_id: '',
};

export const personEntityData: Record<string, string> = {
  personId: '',
};
